export default "__VITE_ASSET__a321b4fc__"